import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import cx from 'classnames';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { BlueCloseIcon, BlueTickIcon } from '../../../../images/icons/WrapSvg';

import DateTimeNodeTree from './DateTimeNodeTree';
import Alert from '../../../dialogs/Alert';
import DownshiftMultiple from '../../../inputs/MultipleInput';
import Auto from '../../../inputs/Auto';
import Loading from '../../../dialogs/loading';

const defaultsLife = [0, 5, 10, 15, 30, 60];
const defaultsWarning = [0, 5, 10, 15, 30, 60];
const defaultsScore = [0, 10, 20, 30, 50, 80];

function helperTextWarning(error, intl) {
    return error ? intl.formatMessage({ id: 'error_warning_life_time' }) : '';
}

class SectionAdd extends React.Component {
    state = {
        edit: false,
        code: randomstring(),
        family: this.props.familyName ? this.props.familyName : '',
        name: '',
        description: '',
        system: false,
        score: 0,
        life: 0,
        warning: 0,
        iflare: false,
        evitarcron: false,
        cliente: this.props.session.info.idCliente,
        programmingTree: [],
        arr_read_permits: [],
        arr_write_permits: [],
        arr_execute_permits: [],
        arr_edition_permits: [],
        arr_end_permits: [],
        arr_reopen_permits: [],
        action_mail_timeout: '',
        action_mail_reopen: '',
        action_mail_close: '',
        tag: '',
        timeout: false,
        sts: false,
        stsnombre: '',
        stsnumero: 0,
        paraTrabajador: false,
        modoTest: false
    };


    constructor(props) {
        super(props);
        if (this.props.codigo) {
            this.props
                .loadManageProcess(this.props.codigo)
                .then((data) => {
                    this.loadInfo(data, this.props.info);
                })
                .catch((error) => console.log(error));
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (
            props.title !== state.title ||
            props.alerts !== state.alerts ||
            props.pending !== state.pending
        ) {
            state.title = props.title;
            state.alerts = props.alerts;
            state.pending = props.pending;
            return state;
        }
        return null;
    }

    loadInfo = (data, info) => {
        console.log(data, this.props.familyName);
        if (data) {
            const read =
                data && data.permisos && data.permisos.mo
                    ? this.parsePermits(data.permisos.vw)
                    : [];

            const write =
                data && data.permisos && data.permisos.vw
                    ? this.parsePermits(data.permisos.mo)
                    : [];
            const exec =
                data && data.permisos && data.permisos.ex
                    ? this.parsePermits(data.permisos.ex)
                    : [];
            const edit =
                data && data.permisos && data.permisos.ex
                    ? this.parsePermits(data.permisos.ed)
                    : [];
            const end =
                data && data.tfinalizar && data.tfinalizar.permisos && data.tfinalizar.permisos.ex
                    ? this.parsePermits(data.tfinalizar.permisos.ex)
                    : [];
            const reopen =
                data && data.treabrir && data.treabrir.permisos && data.treabrir.permisos.ex
                    ? this.parsePermits(data.treabrir.permisos.ex)
                    : [];

            const action_mail_timeout =
                data && data.ttimeout && data.ttimeout.accion
                    ? data.ttimeout.accion.reduce((value, item) => {
                        if (item.accion === 'email') {
                            value = item.parametros.reduce((found, p) => {
                                if (p.codigo === 'check') {
                                    found = p.valor;
                                }
                                return found;
                            }, false);
                        }
                        return value;
                    }, false)
                    : false;
            const action_mail_reopen =
                data && data.treabrir && data.treabrir.accion
                    ? data.treabrir.accion.reduce((value, item) => {
                        if (item.accion === 'email') {
                            value = item.parametros.reduce((found, p) => {
                                if (p.codigo === 'check') {
                                    found = p.valor;
                                }
                                return found;
                            }, false);
                        }
                        return value;
                    }, false)
                    : false;
            const action_mail_close =
                data && data.tfinalizar && data.tfinalizar.accion
                    ? data.tfinalizar.accion.reduce((value, item) => {
                        if (item.accion === 'email') {
                            value = item.parametros.reduce((found, p) => {
                                if (p.codigo === 'check') {
                                    found = p.valor;
                                }
                                return found;
                            }, false);
                        }
                        return value;
                    }, false)
                    : false;

            this.setState({
                code: data.codigo,
                client: data.cliente,
                family: data.familia ? data.familia : this.props.familyName ? this.props.familyName : '',
                name: data.nombre ? data.nombre : '',
                description: data.descripcion ? data.descripcion : '',
                score: parseInt(data.puntuacionmaxima, 10),
                life: data.ttl ? parseInt(data.ttl, 10) : 0,
                warning: data.ttw ? parseInt(data.ttw, 10) : 0,
                iflare: data.iflare,
                programmingTree: this.parseProgramacionTree(
                    info !== undefined ? info.security.locals : [],
                    data.programacion,
                    info.security.hierarchies,
                ),
                evitarcron: data.evitarcron ? true : false,
                arr_read_permits: read,
                arr_write_permits: write,
                arr_execute_permits: exec,
                arr_edition_permits: edit,
                arr_end_permits: end,
                arr_reopen_permits: reopen,
                tag: data.tag,
                action_mail_timeout: action_mail_timeout,
                action_mail_reopen: action_mail_reopen,
                action_mail_close: action_mail_close,
                timeout: data && data.tfinalizar && data.tfinalizar.timeout,
                sts: data.sts ? data.sts : false,
                stsnombre: data.stsnombre,
                stsnumero: data.stsnumero,
                paraTrabajador: data.paraTrabajador ? data.paraTrabajador : false,
                modoTest: data.modoTest ? data.modoTest : false
            });
        }
    };

    parseProgramacionTree = (table, data, root) => {
        const arr = data ? JSON.parse(data) : [];
        const aux2 = arr.reduce((a, r) => {
            const node =
                r.local === null ? root : table.find((f) => f.id === parseInt(r.local, 10));
            const elements = a.find((f) => f.local === parseInt(r.local, 10));
            let element = [
                {
                    day: r.dia,
                    id: randomstring(),
                    week: r.dia.split(','),
                    time: [r.hora],
                },
            ];
            const _new = {
                local: parseInt(r.local, 10),
                node: node,
                days: element,
                id: randomstring(),
            };
            if (elements) {
                const toDelete = a.map((e) => e.local).indexOf(parseInt(r.local, 10));
                a.splice(toDelete, 1);

                const index = elements.days.map((e) => e.day).indexOf(r.dia);
                if (index >= 0) {
                    let e = elements.days.find((f) => f.day === r.dia);
                    elements.days.splice(index, 1);
                    e.time = e.time.concat([r.hora]);
                    elements.days.push(e);
                    element = elements.days;
                } else {
                    element = [...elements.days].concat(element);
                }
            }
            const add = !elements
                ? _new
                : {
                    local: parseInt(r.local, 10),
                    node: node,
                    days: element,
                    id: randomstring(),
                };
            a.push(add);
            return a;
        }, []);
        return aux2;
    };

    parsePermits = (arr) => {
        return arr.roles
            .map((r) => {
                return { id: r.id, name: r.nombre, type: 'rol' };
            })
            .concat(
                arr.usuarios.map((r) => {
                    return { id: r.id, name: r.nombre, type: 'user' };
                }),
            );
    };

    handleClickLife = (value) => (event) => {
        this.setState({
            life: value,
            warning: Math.min(value, this.state.warning),
            edit: true,
        });
    };

    handleClick = (name, value) => (event) => {
        this.setState({
            [name]: value,
            edit: true,
        });
    };

    handleChange = (name) => (event) => {
        this.setState({
            [name]: event.target.value,
            edit: true,
        });
    };

    handleSelect = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            edit: true,
        });
    };

    handleChangeFamily = (value) => {
        this.setState({
            family: value,
            edit: true,
        });
    };

    handleChangeLife = (event) => {
        this.setState({
            life: event.target.value,
            warning: Math.min(event.target.value, this.state.warning),
            edit: true,
        });
    };

    handleUpdatePermits = (name, values) => {
        this.setState({
            [name]: values,
            edit: true,
        });
    };

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked, edit: true });
    };

    getCorrect = () => {
        const {
            family,
            edit,
            name,
            score,
            life,
            warning,
            arr_edition_permits,
            arr_write_permits,
        } = this.state;
        return (
            family &&
            edit &&
            name !== undefined &&
            name.length > 3 &&
            (score === 0 || score) &&
            (life === 0 || life) &&
            (warning === 0 || warning) &&
            parseInt(warning, 10) <= parseInt(life, 10) &&
            arr_edition_permits.length > 0 &&
            arr_write_permits.length > 0
        );
    };

    getPermits = (arr) => {
        return {
            jerarquias: [],
            roles: arr
                .filter((f) => f.type === 'rol')
                .map((m) => {
                    return { id: m.id, nombre: m.name };
                }),
            usuarios: arr
                .filter((f) => f.type === 'user')
                .map((m) => {
                    return { id: m.id, nombre: m.name };
                }),
        };
    };

    getProgramming = (values) => {
        const json = values.reduce((arr, p) => {
            const progs = p.days.reduce((hours, t) => {
                const day = t.time.map((h) => {
                    return {
                        dia: t.day,
                        hora: h,
                        local: p.local,
                        fin: null,
                    };
                });
                hours = hours.concat(day);
                return hours;
            }, []);
            arr = arr.concat(progs);
            return arr;
        }, []);
        return JSON.stringify(json);
    };

    submitData = (event) => {
        const {
            code,
            family,
            name,
            description,
            iflare,
            score,
            life,
            warning,
            arr_read_permits,
            arr_write_permits,
            arr_execute_permits,
            arr_edition_permits,
            arr_end_permits,
            arr_reopen_permits,
            programmingTree,
            evitarcron,
            cliente,
            tag,
            timeout,
            sts,
            stsnombre,
            stsnumero,
            paraTrabajador,
            modoTest
        } = this.state;

        const info = {
            codigo: code,
            cliente: cliente,
            clase: 1,
            tag: tag,
            descripcion: description,
            familia: family.toUpperCase(),
            iflare: iflare,
            metadatos: null,
            nombre: name,
            permisos: {
                ex: this.getPermits(arr_execute_permits),
                mo: this.getPermits(arr_write_permits),
                vw: this.getPermits(arr_read_permits),
                ed: this.getPermits(arr_edition_permits),
            },
            programacion: this.getProgramming(programmingTree),
            puntuacionmaxima: score,
            ttl: parseInt(life, 10),
            ttw: parseInt(warning, 10),
            tfinalizar: {
                permisos: { ex: this.getPermits(arr_end_permits) },
                timeout: timeout
            },
            treabrir: {
                permisos: { ex: this.getPermits(arr_reopen_permits) },
            },
            evitarcron: evitarcron,
            sts: sts,
            stsnombre: stsnombre,
            stsnumero: sts ? stsnumero ? stsnumero : 1 : undefined,
            paraTrabajador: paraTrabajador ? true : false,
            modoTest: modoTest ? true : false
        };
        this.props.add(info);
    };

    scoreComponent = (score) => {
        return (
            <div className="box display_flex">
                <span
                    className={
                        'padding_12 shadow_right hand ' +
                        (score === 0 ? 'c_white bg_bluish box-aux-left' : '')
                    }
                    onClick={this.handleClick('score', 0)}
                >
                    AUTO
                </span>
                <span
                    className={
                        'padding_12 shadow_right hand ' + (score === 10 ? 'c_white bg_bluish' : '')
                    }
                    onClick={this.handleClick('score', 10)}
                >
                    10
                </span>
                <span
                    className={
                        'padding_12 shadow_right hand ' + (score === 20 ? 'c_white bg_bluish' : '')
                    }
                    onClick={this.handleClick('score', 20)}
                >
                    20
                </span>
                <span
                    className={
                        'padding_12 shadow_right hand ' + (score === 30 ? 'c_white bg_bluish' : '')
                    }
                    onClick={this.handleClick('score', 30)}
                >
                    30
                </span>
                <span
                    className={
                        'padding_12 shadow_right hand ' + (score === 50 ? 'c_white bg_bluish' : '')
                    }
                    onClick={this.handleClick('score', 50)}
                >
                    50
                </span>
                <span
                    className={
                        'padding_12 shadow_right hand ' + (score === 80 ? 'c_white bg_bluish' : '')
                    }
                    onClick={this.handleClick('score', 80)}
                >
                    80
                </span>
                <span
                    className={
                        'padding_12 hand  ' +
                        (score !== undefined && defaultsScore.indexOf(score) === -1
                            ? 'c_white bg_bluish box-aux'
                            : '')
                    }
                    onClick={this.handleClick('score', '')}
                >
                    <FormattedMessage id="form_section_others" />
                </span>
            </div>
        );
    };

    lifeTimeComponent = (life) => {
        return (
            <div className="box display_flex">
                <span
                    className={
                        'padding_12 shadow_right hand ' +
                        (life === 0 ? 'c_white bg_bluish box-aux-left' : '')
                    }
                    onClick={this.handleClickLife(0)}
                >
                    N/A
                </span>
                <span
                    className={
                        'padding_12 shadow_right hand ' + (life === 5 ? 'c_white bg_bluish' : '')
                    }
                    onClick={this.handleClickLife(5)}
                >
                    5
                </span>
                <span
                    className={
                        'padding_12 shadow_right hand ' + (life === 10 ? 'c_white bg_bluish' : '')
                    }
                    onClick={this.handleClickLife(10)}
                >
                    10
                </span>
                <span
                    className={
                        'padding_12 shadow_right hand ' + (life === 15 ? 'c_white bg_bluish' : '')
                    }
                    onClick={this.handleClickLife(15)}
                >
                    15
                </span>
                <span
                    className={
                        'padding_12 shadow_right hand ' + (life === 30 ? 'c_white bg_bluish' : '')
                    }
                    onClick={this.handleClickLife(30)}
                >
                    30
                </span>
                <span
                    className={
                        'padding_12 shadow_right hand ' + (life === 60 ? 'c_white bg_bluish' : '')
                    }
                    onClick={this.handleClickLife(60)}
                >
                    60
                </span>
                <span
                    className={
                        'padding_12 hand  ' +
                        (life !== undefined && defaultsLife.indexOf(life) === -1
                            ? 'c_white bg_bluish box-aux'
                            : '')
                    }
                    onClick={this.handleClickLife('')}
                >
                    <FormattedMessage id="form_section_others" />
                </span>
            </div>
        );
    };

    warningTimeComponent = (life, warning) => {
        return (
            <div className="box display_flex">
                <span
                    className={cx(
                        'padding_12 shadow_right hand ',
                        life < 0
                            ? 'c_grey_blue bg_black_10 box-aux-left'
                            : warning === 0
                                ? 'c_white bg_bluish box-aux-left'
                                : '',
                    )}
                    onClick={life >= 0 ? this.handleClick('warning', 0) : null}
                >
                    N/A
                </span>
                <span
                    className={cx(
                        'padding_12 shadow_right hand ',
                        life < 5
                            ? 'c_grey_blue bg_black_10'
                            : warning === 5
                                ? 'c_white bg_bluish '
                                : '',
                    )}
                    onClick={life >= 5 ? this.handleClick('warning', 5) : null}
                >
                    5
                </span>
                <span
                    className={cx(
                        'padding_12 shadow_right hand ',
                        life < 10
                            ? 'c_grey_blue bg_black_10 '
                            : warning === 10
                                ? 'c_white bg_bluish '
                                : '',
                    )}
                    onClick={life >= 10 ? this.handleClick('warning', 10) : null}
                >
                    10
                </span>
                <span
                    className={cx(
                        'padding_12 shadow_right hand ',
                        life < 15
                            ? 'c_grey_blue bg_black_10 '
                            : warning === 15
                                ? 'c_white bg_bluish '
                                : '',
                    )}
                    onClick={life >= 15 ? this.handleClick('warning', 15) : null}
                >
                    15
                </span>
                <span
                    className={cx(
                        'padding_12 shadow_right hand ',
                        life < 30
                            ? 'c_grey_blue bg_black_10 '
                            : warning === 30
                                ? 'c_white bg_bluish '
                                : '',
                    )}
                    onClick={life >= 30 ? this.handleClick('warning', 30) : null}
                >
                    30
                </span>
                <span
                    className={cx(
                        'padding_12 shadow_right hand ',
                        life < 60
                            ? 'c_grey_blue bg_black_10 '
                            : warning === 60
                                ? 'c_white bg_bluish '
                                : '',
                    )}
                    onClick={life >= 60 ? this.handleClick('warning', 60) : null}
                >
                    60
                </span>
                <span
                    className={
                        'padding_12 hand  ' +
                        (warning !== undefined && defaultsLife.indexOf(warning) === -1
                            ? 'c_white bg_bluish box-aux'
                            : '')
                    }
                    onClick={this.handleClick('warning', '')}
                >
                    <FormattedMessage id="form_section_others" />
                </span>
            </div>
        );
    };

    handleChangeProgramming = (programmingTree) => {
        this.setState({ programmingTree: programmingTree, edit: true });
    };

    handleClose = (event) => {
        const { edit } = this.state;
        const { onClose } = this.props;
        if (edit) {
            this.setState({ alert: true });
        } else {
            onClose(event);
        }
    };

    handleCancelClose = (event) => {
        this.setState({ alert: false });
    };

    render() {
        const {
            family,
            alert,
            name,
            description,
            score,
            life,
            warning,
            iflare,
            evitarcron,
            arr_read_permits,
            arr_write_permits,
            arr_execute_permits,
            arr_edition_permits,
            arr_end_permits,
            arr_reopen_permits,
            programmingTree,
            tag,
            timeout,
            sts,
            stsnombre,
            stsnumero,
            paraTrabajador,
            modoTest
        } = this.state;

        console.log(this.props.familyName);

        const {
            open,
            intl,
            info,
            title,
            onClose,
            manage_process,
            manage_process_is_loading,
        } = this.props;

        const suggestions =
            info !== undefined && info.security !== undefined
                ? info.security.suggestions
                : undefined;

        const stsAvailable = info.security.licencias.some((f) => f.id === 157 && f.activo);
        return (
            <Dialog
                open={open}
                onClose={(e) => this.handleClose(e)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullScreen
                className="z_index_dialog"
            >
                {manage_process_is_loading && <Loading open opacity />}
                {alert && (
                    <Alert
                        title="alert_dialog_discard_title"
                        text="alert_dialog_discard_message"
                        open={true}
                        onCancel={(e) => this.handleCancelClose(e)}
                        onConfirm={(e) => onClose(e)}
                    />
                )}
                <div className={'flex_header'}>
                    <div className={'flex_full_row padding_borders shadow'}>
                        <BlueCloseIcon
                            color="primary"
                            onClick={(e) => this.handleClose(e)}
                            className="margin_right_18 hand"
                        />
                        <span className={'barlowsemicondensed_bold flex_full c_dark_grey_blue '}>
                            <FormattedMessage id={title} />
                        </span>
                        {this.getCorrect() ? (
                            <BlueTickIcon
                                className="hand"
                                color="primary"
                                onClick={this.submitData}
                            />
                        ) : (
                                <div />
                            )}
                    </div>
                </div>
                <DialogContent>
                    <div className="flex_full_column margin_top_9 padding_bottom_48">
                        <div className="flex_full_row c_bluish barlow_semibold_label padding_top_24 elements_center">
                            <Auto
                                initialValue={family}
                                placeholder={intl.formatMessage({ id: 'family' })}
                                onChange={this.handleChangeFamily.bind(this)}
                                dictionary={manage_process.families}
                                isRequired={intl.formatMessage({ id: 'required' })}
                            />
                        </div>
                        <TextField
                            autoFocus
                            id="name"
                            required
                            error={!name || name.length < 4}
                            helperText={
                                !name || name.length === 0
                                    ? intl.formatMessage({ id: 'required' })
                                    : name.length < 4
                                        ? intl.formatMessage({ id: 'min_length_4' })
                                        : ''
                            }
                            label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                            className={'flex_full_row upper'}
                            value={name}
                            onChange={this.handleChange('name')}
                            margin="normal"
                        />
                        <TextField
                            id="description"
                            multiline
                            label={intl.formatMessage({ id: 'form_field_description' })}
                            className={'flex_full_row'}
                            value={description}
                            onChange={this.handleChange('description')}
                            margin="normal"
                        />
                        <TextField
                            id="tag"
                            multiline
                            label={intl.formatMessage({ id: 'form_field_name_tag' })}
                            className={'flex_full_row'}
                            value={tag}
                            onChange={this.handleChange('tag')}
                            margin="normal"
                        />
                        <div className="flex_full_row margin_top_32 align_center">
                            <div className="flex_full_column">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="visibility_in_paraTrabajador" />
                                </div>
                            </div>
                            <div className="flex_auto_column">
                                <Switch
                                    name={'paraTrabajador'}
                                    checked={paraTrabajador}
                                    onChange={this.handleChecked}
                                    value="paraTrabajador"
                                    color="primary"
                                />
                            </div>
                        </div>
                        <div className="flex_full_row margin_top_32 align_center">
                            <div className="flex_full_column">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="visibility_in_modoTest" />
                                </div>
                            </div>
                            <div className="flex_auto_column">
                                <Switch
                                    name={'modoTest'}
                                    checked={modoTest}
                                    onChange={this.handleChecked}
                                    value="modoTest"
                                    color="primary"
                                />
                            </div>
                        </div>
                        {stsAvailable &&
                            <div className="flex_auto_column">
                                <Divider className={'margin_top_18 margin_bottom_12'} />
                                <div className={'flex_full_row barlow_semibold padding_top_24 c_dark_grey_blue'} >
                                    {"STS"}
                                </div>
                                <div className="flex_full_row margin_top_32 align_center">
                                    <div className="flex_full_column">
                                        <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                            <FormattedMessage id="visibility_in_sts" />
                                        </div>
                                    </div>
                                    <div className="flex_auto_column">
                                        <Switch
                                            name={'sts'}
                                            checked={sts}
                                            onChange={this.handleChecked}
                                            value="sts"
                                            color="primary"
                                        />
                                    </div>
                                </div>
                                <TextField
                                    id="stsnombre"
                                    multiline
                                    disabled={!sts}
                                    label={intl.formatMessage({ id: 'visibility_name_public' })}
                                    className={'flex_full_row'}
                                    value={sts ? stsnombre : ''}
                                    onChange={this.handleChange('stsnombre')}
                                    margin="normal"
                                />
                                <div className="flex_full_row margin_top_32 align_center">
                                    <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                                        <InputLabel htmlFor="age-native-simple" shrink>
                                            {intl.formatMessage({ id: 'visibility_historic_number' })}
                                        </InputLabel>
                                        <Select
                                            native
                                            value={sts ? stsnumero : undefined}
                                            disabled={!sts}
                                            onChange={this.handleChange('stsnumero')}
                                            inputProps={{ name: 'stsnumero', id: 'stsnumero' }}
                                        >
                                            <option key={randomstring()} value={undefined} />
                                            <option key={randomstring()} value={1} > 1 </option>
                                            <option key={randomstring()} value={2} > 2 </option>
                                            <option key={randomstring()} value={3} > 3 </option>
                                            <option key={randomstring()} value={4} > 4 </option>
                                            <option key={randomstring()} value={5} > 5 </option>
                                            <option key={randomstring()} value={6} > 6 </option>
                                            <option key={randomstring()} value={7} > 7 </option>
                                            <option key={randomstring()} value={8} > 8 </option>
                                            <option key={randomstring()} value={9} > 9 </option>
                                            <option key={randomstring()} value={10} > 10 </option>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        }
                        <Divider className={'margin_top_18 margin_bottom_12'} />
                        <div
                            className={
                                'flex_full_row barlow_semibold padding_top_24 ' +
                                (score === 0 || score ? 'c_dark_grey_blue' : 'c_lipstick')
                            }
                        >
                            <FormattedMessage id="form_section_score" />
                        </div>
                        <div className="flex_full_row c_bluish barlow_semibold_label padding_top_24 elements_center">
                            {this.scoreComponent(score)}
                        </div>
                        {score !== undefined && defaultsScore.indexOf(score) === -1 && (
                            <TextField
                                id="score"
                                label={intl.formatMessage({
                                    id: 'form_section_tab_custom_score',
                                })}
                                className={'flex_full_row'}
                                onChange={this.handleChange('score')}
                                margin="normal"
                                value={score}
                                type="number"
                                inputProps={{ pattern: '[0-9]*' }}
                            />
                        )}
                        <Divider className={'margin_top_18 margin_bottom_12'} />
                        <div
                            className={
                                'flex_full_row barlow_semibold padding_top_24 ' +
                                (life === 0 || life ? 'c_dark_grey_blue' : 'c_lipstick')
                            }
                        >
                            <FormattedMessage id="form_section_life_time" />
                        </div>
                        <div className="flex_full_row c_bluish barlow_semibold_label padding_top_24 elements_center">
                            {this.lifeTimeComponent(life)}
                        </div>
                        {life !== undefined && defaultsLife.indexOf(life) === -1 && (
                            <TextField
                                id="life"
                                label={intl.formatMessage({ id: 'form_section_life_time' })}
                                className={'flex_full_row'}
                                value={life}
                                onChange={this.handleChangeLife}
                                margin="normal"
                                type="number"
                                inputProps={{ pattern: '[0-9]*' }}
                            />
                        )}
                        <div
                            className={
                                'flex_full_row barlow_semibold padding_top_24 ' +
                                (warning === 0 || warning ? 'c_dark_grey_blue' : 'c_lipstick')
                            }
                        >
                            <FormattedMessage id="form_section_warning_time" />
                        </div>
                        <div className="flex_full_row c_bluish barlow_semibold_label padding_top_24 elements_center">
                            {this.warningTimeComponent(life, warning)}
                        </div>
                        {warning !== undefined && defaultsWarning.indexOf(warning) === -1 && (
                            <TextField
                                id="life"
                                error={parseInt(warning, 10) >= parseInt(life, 10)}
                                helperText={helperTextWarning(
                                    parseInt(warning, 10) >= parseInt(life, 10),
                                    intl,
                                )}
                                label={intl.formatMessage({ id: 'form_section_warning_time' })}
                                className={'flex_full_row'}
                                value={warning}
                                onChange={this.handleChange('warning')}
                                margin="normal"
                                type="number"
                                inputProps={{ pattern: '[0-9]*' }}
                            />
                        )}
                        <Divider className={'margin_top_18 margin_bottom_12'} />
                        <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_24">
                            <FormattedMessage id="form_process_iflare_title" />
                        </div>
                        <div className="flex_full_row margin_top_32 align_center">
                            <div className="flex_full_column">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="form_field_timeout" />
                                </div>
                            </div>
                            <div className="flex_auto_column">
                                <Switch
                                    name={'timeout'}
                                    checked={timeout}
                                    onChange={this.handleChecked}
                                    value="timeout"
                                    color="primary"
                                />
                            </div>
                        </div>
                        <div className="flex_full_row padding_top_24 align_center">
                            <div className="flex_full_column">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="form_process_iflare_text" />
                                </div>
                            </div>
                            <div className="flex_auto_column">
                                <Switch
                                    name="iflare"
                                    checked={iflare}
                                    onChange={this.handleChecked}
                                    value="iflare"
                                    color="primary"
                                />
                            </div>
                        </div>

                        <Divider className={'margin_top_18 margin_bottom_12'} />
                        <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_24">
                            <FormattedMessage id="form_process_programming_title" />
                        </div>
                        <div className="flex_full_row margin_top_32 align_center">
                            <div className="flex_full_column">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="form_field_name_avoid_cron" />
                                </div>
                            </div>
                            <div className="flex_auto_column">
                                <Switch
                                    name={'evitarcron'}
                                    checked={evitarcron}
                                    onChange={this.handleChecked}
                                    value="evitarcron"
                                    color="primary"
                                />
                            </div>
                        </div>
                        <div className="flex_full_row padding_top_24 align_center">
                            <DateTimeNodeTree
                                tree={this.props.info.security.hierarchies}
                                programmingTree={programmingTree}
                                onChange={this.handleChangeProgramming}
                                showTime={true}
                            />
                        </div>
                        <Divider className={'margin_top_18 margin_bottom_12'} />
                        <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_24">
                            <FormattedMessage id="form_field_read_permits" />
                        </div>
                        <DownshiftMultiple
                            id="read_permits"
                            label={intl.formatMessage({ id: 'form_field_user_roles_hierarchies' })}
                            suggestions={suggestions}
                            value={arr_read_permits}
                            name="arr_read_permits"
                            onChange={this.handleUpdatePermits}
                        />
                        <Divider className={'margin_top_18 margin_bottom_12'} />
                        <div
                            className={
                                'flex_full_row  barlow_semibold padding_top_24 ' +
                                (arr_write_permits.length > 0 ? 'c_dark_grey_blue' : 'c_lipstick')
                            }
                        >
                            <FormattedMessage id="form_field_write_permits" />
                        </div>
                        <DownshiftMultiple
                            id="write_permits"
                            label={intl.formatMessage({ id: 'form_field_user_roles_hierarchies' })}
                            suggestions={suggestions}
                            value={arr_write_permits}
                            name="arr_write_permits"
                            onChange={this.handleUpdatePermits}
                        />
                        <Divider className={'margin_top_18 margin_bottom_12'} />
                        <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_24">
                            <FormattedMessage id="form_field_execute_permits" />
                        </div>
                        <DownshiftMultiple
                            id="execute_permits"
                            label={intl.formatMessage({ id: 'form_field_user_roles_hierarchies' })}
                            suggestions={suggestions}
                            value={arr_execute_permits}
                            name="arr_execute_permits"
                            onChange={this.handleUpdatePermits}
                        />
                        <div
                            className={
                                'flex_full_row barlow_semibold padding_top_24 ' +
                                (arr_edition_permits.length > 0 ? 'c_dark_grey_blue' : 'c_lipstick')
                            }
                        >
                            <FormattedMessage id="form_field_edition_permits" />
                        </div>
                        <DownshiftMultiple
                            id="edition_permits"
                            label={intl.formatMessage({ id: 'form_field_user_roles_hierarchies' })}
                            suggestions={suggestions}
                            value={arr_edition_permits}
                            name="arr_edition_permits"
                            onChange={this.handleUpdatePermits}
                        />

                        <div
                            className={
                                'flex_full_row barlow_semibold padding_top_24 c_dark_grey_blue'
                            }
                        >
                            <FormattedMessage id="form_field_reopen_permits" />
                        </div>
                        <DownshiftMultiple
                            id="edition_permits"
                            label={intl.formatMessage({
                                id: 'form_field_user_roles_hierarchies_default',
                            })}
                            suggestions={suggestions}
                            value={arr_reopen_permits}
                            name="arr_reopen_permits"
                            onChange={this.handleUpdatePermits}
                        />
                        <div
                            className={
                                'flex_full_row barlow_semibold padding_top_24 c_dark_grey_blue'
                            }
                        >
                            <FormattedMessage id="form_field_close_permits" />
                        </div>
                        <DownshiftMultiple
                            id="edition_permits"
                            label={intl.formatMessage({
                                id: 'form_field_user_roles_hierarchies_default',
                            })}
                            suggestions={suggestions}
                            value={arr_end_permits}
                            name="arr_end_permits"
                            onChange={this.handleUpdatePermits}
                        />

                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

SectionAdd.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
        session: state.session,
        manage_process: state.manage_process,
        manage_process_is_loading: state.manage_process_is_loading,
    };
};

SectionAdd = connect(
    mapStateToProps,
    null,
)(SectionAdd);

SectionAdd = injectIntl(SectionAdd);

export default SectionAdd;



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/ProcessAdd.js